export default "__VITE_ASSET__0SWH_uT9__"